import Button from 'components/button';
import React, { PropsWithChildren } from 'react';
import { IFormFieldProps } from './common';
import InputWrap from './InputWrap';
import styles from './styles/TextInput.module.scss';

const TextInput = (
  {
    basic,
    children,
    label,
    labelAfter,
    className,
    inputClassName,
    inputImg,
    inputWrapClassName,
    labelClassName,
    leftIcon,
    rightIcon,
    error,
    scrollIntoView,
    tooltip,
    showButton,
    buttonText = 'Search',
    buttonDisabled,
    onButtonClick,
    ...inputProps
  }: PropsWithChildren<IFormFieldProps & React.HTMLProps<HTMLInputElement>>,
  ref: React.Ref<HTMLInputElement>,
) => {
  return (
    <InputWrap
      className={classnames(className, !!inputImg && styles.withImg)}
      errorClassName={classnames(styles.error, basic && styles.basicError)}
      error={error}
      inputImg={inputImg}
      inputWrapClassName={inputWrapClassName}
      label={label}
      labelAfter={labelAfter}
      labelClassName={labelClassName}
      name={inputProps.name}
      rightIcon={rightIcon}
      scrollIntoView={scrollIntoView}
      tooltip={tooltip}
    >
      <input
        ref={ref}
        id={inputProps.name}
        {...inputProps}
        className={classnames(
          styles.input,
          basic && styles.basic,
          inputClassName,
        )}
      />
      {showButton && (
        <Button
          type="button"
          className={styles.button}
          onClick={onButtonClick}
          text={buttonText}
          disabled={buttonDisabled}
        />
      )}
      {children}
    </InputWrap>
  );
};

export default React.forwardRef(TextInput);
